<template>
  <ul>
    <li v-if="shared.state.categories.length" style="margin-bottom: 18px;">
      <router-link to="/" :class="{active: isActive()}">All</router-link>
    </li>
    <li v-for="category in shared.state.categories"
        :key="category.sys.id">
      <router-link :to="'/category/' + category.sys.id" :class="{active: isActive(category.sys.id)}">
        {{category.fields.title}}
      </router-link>
    </li>
  </ul>
</template>
<script>
import store from '../store'
export default {
  name: 'workCategories',
  data () {
    return {
      shared: store
    }
  },
  created () {
    store.getCategories()
  },
  watch: {
    'shared.state.project.fields.category.sys.id': function () {
      this.$forceUpdate()
    }
  },
  methods: {
    isActive (category) {
      if (this.$route.params.category === category && category) {
        return true
      } else if (this.$route.params.id && this.shared.state.project.fields.category) {
        if (this.shared.state.project.fields.category.sys.id === category) {
          return true
        }
      } else if (!(this.$route.params.category || category)) {
        return true
      }

      return false
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  li {
    list-style: none;
    text-align: right;
  }
  li a{
    text-decoration:none;
    color:#FFF;
    font-family:'Roboto Slab';
    font-weight:300;
    font-size:16px;
    line-height:18px;
    transition:all 0.3s;
  }
  li a:hover{
    color:#000;
    background:#CCC;
  }

   .active {
      color: #000;
      background: #FFF;
    }
</style>



// WEBPACK FOOTER //
// src/components/WorkCategories.vue